export default '/annuaire/@code/*'